const TIME_CONSTANTS = {
  DEBOUNCE_SEARCH_TIME: 500,
  EXPIRE_ACCESSED_TIME: 5,
};

export default TIME_CONSTANTS;
